import { render, staticRenderFns } from "./heightdetails.vue?vue&type=template&id=9e643638"
import script from "./heightdetails.vue?vue&type=script&lang=js"
export * from "./heightdetails.vue?vue&type=script&lang=js"
import style0 from "./heightdetails.vue?vue&type=style&index=0&id=9e643638&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports